import Home from "./Home.svelte";
import Demos from "./demos/index.svelte";
import About from "./About.svelte";
import NotFound from "./NotFound.svelte";
import Google from "./demos/Google.svelte";
import Twitter from "./demos/Twitter.svelte";
import Youtube from "./demos/Youtube.svelte";
import Instagram from "./demos/Instagram.svelte";
import Pinterest from "./demos/Pinterest.svelte";
import XorAcademy from "./demos/XorAcademy.svelte";
import XorAcademyWatch from "./demos/XorAcademyWatch.svelte";
import Login from "./demos/Login.svelte";

export default {
  "/": Home,
  "/about": About,
  "/demos": Demos,
  "/demos/login": Login,
  "/demos/google": Google,
  "/demos/twitter": Twitter,
  "/demos/youtube": Youtube,
  "/demos/instagram": Instagram,
  "/demos/pinterest": Pinterest,
  "/demos/xoracademy": XorAcademy,
  "/demos/xoracademy/watch": XorAcademyWatch,
  "*": NotFound,
}
